import './index.less';
import HomepageV4IntroCard from './Card';
import { AGENTIC_CARDS } from '@/shared/constants/homepage-constants';
import Marquee from 'react-fast-marquee';

const HomepageV4IntroCards = () => {
  return (
    <Marquee className="home-page-intro-cards-marquee" pauseOnHover pauseOnClick autoFill>
      {AGENTIC_CARDS.map((card, index) => (
        <HomepageV4IntroCard key={index} card={card} />
      ))}
    </Marquee>
  );
};

export default HomepageV4IntroCards;
